var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.17036 7.17817L4.42503 6.9235L4.32003 6.57899C4.1856 6.13789 4.1 5.69756 4.1 5.25C4.1 2.68293 6.18293 0.6 8.75 0.6C11.3171 0.6 13.4 2.68293 13.4 5.25C13.4 7.81707 11.3171 9.9 8.75 9.9C8.30244 9.9 7.86211 9.8144 7.42101 9.67997L7.0765 9.57498L6.82183 9.82964L5.58481 11.0667H4.66667H4.06667V11.6667V12.2333H3.5H2.9V12.8333V13.4H0.6V10.7485L4.17036 7.17817Z",
    stroke: "#00A3FA",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 4.5,
    r: 1.5,
    fill: "#00A3FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/key-icon.01a55ce2b870e73941b70cddf5fa3303.svg";
export { ForwardRef as ReactComponent };